/* eslint @typescript-eslint/no-explicit-any: ['off'] -- "any" types are intentional */
/**
 * get nested object value
 *
 * usage: getValueFromNestedObject(someObj, 'part3[0].name');
 *
 * idea from: https://stackoverflow.com/a/6491621
 */
export function getValueFromNestedObjectProp(
  object: Record<string, unknown>,
  pathString: string,
): any {
  try {
    let cleanPathString = pathString.replace(/\[(\w+)]/g, '.$1') // convert indexes to properties
    cleanPathString = cleanPathString.replace(/^\./, '') // strip a leading dot

    const pathSegments: string[] = cleanPathString.split('.')

    let result: any = object
    if (result) {
      for (const e of pathSegments) {
        if (
          result
          && typeof result === 'object'
          && e in result
        ) {
          result = result[e]
        } else {
          return
        }
      }
    }

    return result
  } catch (e) {
    console.log('Error in: getValueFromNestedObjectProp', e)
  }
}
